import { LegacyDateRangeFilter, ReceiptAlertTypeFilter } from '@synergy/components';
import { PaloFilterModal } from '@synergy/components-palo';

import { ClassificationsFilter } from '../../../common/components/filter/classifications-filter';
import { CustomerContactFilter } from '../../../common/components/filter/customer-contact-filter';
import { CustomerFilter } from '../../../common/components/filter/customer-filter';
import { DashboardTabs } from '../model/dashboard-tabs';
import { DocumentStatusFilter } from '../../../common/components/filter/document-status-filter';
import { LegacySupplierFilter } from '../../../common/components/filter/legacy-supplier-filter';
import { ResponsibleContactFilter } from '../../../common/components/filter/responsible-contact-filter';
import { SalesOrderTypeFilter } from '../../../common/components/filter/salesorder-type-filter';
import { fetchAllClassifications } from '../../configuration/organization/classifications/store/classifications-actions';
import { useAppSelector } from '../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

export const DashboardFilterModal = ({ tab }: { tab: DashboardTabs }) => {
    const dispatch = useThunkDispatch();
    const classifications = useAppSelector(state => state.classifications.classifications.items);

    return (
        <PaloFilterModal>
            <LegacyDateRangeFilter />
            <ResponsibleContactFilter />
            {/* The statuses of the open tab's kind, several at once (#2340). */}
            <DocumentStatusFilter list={tab} />
            <SalesOrderTypeFilter />
            <CustomerFilter />
            <CustomerContactFilter />
            <LegacySupplierFilter />
            <ClassificationsFilter
                classifications={classifications}
                fetchClassifications={() => dispatch(fetchAllClassifications())}
            />
            {/* As in the lists (#2340). */}
            <ReceiptAlertTypeFilter />
        </PaloFilterModal>
    );
};
